var Wdot;
(function (Wdot) {
    var Maps;
    (function (Maps) {
        var BingMapsHelpers = (function () {
            function BingMapsHelpers() {
            }
            BingMapsHelpers.getIrefIndexValuesFromPoint = function (ref) {
                var polygonNum = parseInt(ref.substring(ref.lastIndexOf('_') + 1)), index = parseInt(ref.substring(0, ref.lastIndexOf('_')));
                return { polygonNum: polygonNum, index: index };
            };
            BingMapsHelpers.getTripRandomizerPinOptionsEnum = function (tripCategory, isHighlight) {
                if (isHighlight) {
                    switch (tripCategory) {
                        case Wdot.Enums.TripThemeEnum.Play:
                            return Wdot.Enums.PushPinOptionsEnum.PinImageForTripCityPlayLocationsHighlighted;
                        case Wdot.Enums.TripThemeEnum.Stay:
                            return Wdot.Enums.PushPinOptionsEnum.PinImageForTripCityStayLocationsHighlighted;
                        case Wdot.Enums.TripThemeEnum.Eat:
                            return Wdot.Enums.PushPinOptionsEnum.PinImageForTripCityEatLocationsHighlighted;
                        case Wdot.Enums.TripThemeEnum.Event:
                            return Wdot.Enums.PushPinOptionsEnum.PinImageForTripCityEventLocationsHighlighted;
                    }
                }
                else {
                    switch (tripCategory) {
                        case Wdot.Enums.TripThemeEnum.Play:
                            return Wdot.Enums.PushPinOptionsEnum.PinImageForTripCityPlayLocations;
                        case Wdot.Enums.TripThemeEnum.Stay:
                            return Wdot.Enums.PushPinOptionsEnum.PinImageForTripCityStayLocations;
                        case Wdot.Enums.TripThemeEnum.Eat:
                            return Wdot.Enums.PushPinOptionsEnum.PinImageForTripCityEatLocations;
                        case Wdot.Enums.TripThemeEnum.Event:
                            return Wdot.Enums.PushPinOptionsEnum.PinImageForTripCityEventLocations;
                    }
                }
            };
            BingMapsHelpers.getInfoboxHtmlString = function (title, address, description, websiteUrl, showCloseButton, topOffset, wrapperClasses = "") {
                //console.log('getInfoboxHtmlString');
                var htmlContentString = "<div class=\"MicrosoftMap BingTheme " + wrapperClasses + " \" style=\"position: relative; left: -8px; top: " + topOffset + "px\">\n                                            <div class=\"Infobox2\" style=\"width:276px;\">";
                if (showCloseButton) {
                    htmlContentString += "<a class=\"infobox-close\" href=\"javascript:Wdot.Maps.MultiPinMapNumberedPins.closeInfobox()\">x</a>";
                }
                htmlContentString += "<div class=\"infobox-body pt-4 pr-4 \">\n                                      <div class=\"infobox-title user-select-none\">" + title + "</div>\n                                      <div class=\"infobox-info\">";
                if (description) {
                    htmlContentString += "<p class=\"user-select-none\">" + description + "</p>";
                }
                if (address) {
                    htmlContentString += "<a target=\"_blank\" href=\"//www.bing.com/maps/default.aspx?rtp=~adr." + encodeURI(address) + "\" onclick=\"ga('send', 'event', 'External Links', '" + decodeURI(title) + "', 'Map - Directions');\">Get Directions</a><br />";
                }
                if (websiteUrl) {
                    htmlContentString += "<a target=\"_blank\" href=\"" + encodeURI(websiteUrl) + "\" onclick=\"ga('send', 'event', 'External Links', '" + decodeURI(title) + "', 'Map - Website');\">Website</a>&nbsp;";
                }
                htmlContentString += "</div></div><div class=\"infobox-stalk\"></div></div></div>";
                return htmlContentString;
            };
            return BingMapsHelpers;
        }());
        Maps.BingMapsHelpers = BingMapsHelpers;
    })(Maps = Wdot.Maps || (Wdot.Maps = {}));
})(Wdot || (Wdot = {}));